const numContractsHeader = {
  text: '# Contracts',
  value: 'quantity',
  sortable: true,
  sortByField: 'quantity',
  tableOrder: 3,
};
const positionSideHeader = {
  text: 'Position Side',
  value: 'positionSide',
  sortable: false,
  tableOrder: 20,
};
const futuresDateHeader = {
  text: 'Futures Date',
  value: 'futuresDate',
  sortable: false,
  tableOrder: 21,
};
const futuresPriceHeader = {
  text: 'Futures Price',
  value: 'futuresPrice',
  sortable: false,
  tableOrder: 22,
};
const optionStrategyHeader = {
  text: 'Strategy',
  value: 'optionStrategy',
  sortable: false,
  tableOrder: 23,
};
const strikePriceHeader = {
  text: 'Strike Price',
  value: 'strikePrice',
  sortable: false,
  tableOrder: 24,
};

export const contractHeaders = {
  amountLeftToDeliver: {
    text: 'Amount left to deliver',
    value: 'amountLeftToDeliver',
    default: true,
    sortable: true,
    sortByField: 'delivery_remaining',
    tableOrder: 6,
    unitType: 'Production',
  },
  buyer: {
    text: 'Buyer',
    value: 'buyer',
    icon: 'mdi-truck',
    default: true,
    sortable: true,
    sortByField: 'buyer',
    tableOrder: 1,
  },
  overdeliveredTooltip: {
    text: '',
    value: 'overdelivered',
    default: true,
    sortable: false,
    tableOrder: 2,
    width: 16,
    hideFromFilters: true,
  },
  commodity: {
    text: 'Commodity',
    value: 'commodity',
    default: true,
    sortable: true,
    sortByField: 'commodity',
    tableOrder: 7,
  },
  contractIdentifier: {
    text: 'Contract ID',
    value: 'contractIdentifier',
    default: true,
    sortable: true,
    sortByField: 'contract_identifier',
    tableOrder: 0,
  },
  contractType: {
    text: 'Contract Type',
    value: 'contractType',
    default: true,
    sortable: true,
    sortByField: 'contract_type',
    tableOrder: 8,
  },
  deliveryPeriod: {
    text: 'Delivery Period',
    value: 'deliveryPeriod',
    default: true,
    sortable: true,
    sortByField: 'delivery_start',
    // sort: (a, b) => a.localeCompare(b), // If we need to client-side sort on mobile
    tableOrder: 5,
  },
  price: {
    text: 'Price',
    value: 'price',
    default: true,
    sortable: true,
    sortByField: 'given_price',
    tableOrder: 4,
    unitType: 'Price',
  },
  priced: {
    text: 'Priced',
    value: 'priced',
    default: true,
    sortable: true,
    sortByField: 'priced',
    tableOrder: 16,
    hideFromFilters: false,
  },
  quantity: {
    text: 'Quantity',
    value: 'quantity',
    default: true,
    sortable: true,
    sortByField: 'quantity',
    tableOrder: 3,
    unitType: 'Production',
  },
  comments: {
    text: 'Comments',
    value: 'comments',
    sortable: true,
    sortByField: 'comments',
    tableOrder: 9,
    cellClass: 'min-w-320',
  },
  contractDate: {
    text: 'Contract Date',
    value: 'contractDate',
    sortable: true,
    sortByField: 'contract_written',
    tableOrder: 10,
  },
  cropYear: {
    text: 'Crop Year',
    value: 'cropYear',
    sortable: true,
    sortByField: 'crop_year',
    tableOrder: 11,
  },
  factors: {
    text: 'Factors',
    value: 'factors',
    sortable: true,
    sortByField: 'factors',
    tableOrder: 12,
  },
  lockinPrice: {
    text: 'Lockin Price',
    value: 'lockinPrice',
    sortable: true,
    sortByField: 'average_cash_price',
    tableOrder: 13,
    unitType: 'Price',
  },
  pricingType: {
    text: 'Pricing Type',
    value: 'pricingType',
    sortable: true,
    sortByField: 'price_type',
    tableOrder: 14,
  },
  terms: {
    text: 'Terms',
    value: 'terms',
    sortable: true,
    sortByField: 'terms',
    tableOrder: 15,
  },
  expiryDate: {
    text: 'Expiry Date',
    value: 'expiryDate',
    sortable: true,
    sortByField: 'expiry_date',
    tableOrder: 17,
  },
};

export const CONTRACT_TYPE_COLUMNS = {
  all: [
    contractHeaders.contractIdentifier,
    contractHeaders.contractType,
    contractHeaders.commodity,
    contractHeaders.quantity,
    contractHeaders.price,
  ],
  sales: [
    contractHeaders.contractIdentifier,
    contractHeaders.overdeliveredTooltip,
    contractHeaders.buyer,
    contractHeaders.commodity,
    contractHeaders.quantity,
    contractHeaders.pricingType,
    contractHeaders.price,
    contractHeaders.lockinPrice,
    contractHeaders.deliveryPeriod,
    contractHeaders.amountLeftToDeliver,
  ],
  production: [
    contractHeaders.contractIdentifier,
    contractHeaders.overdeliveredTooltip,
    contractHeaders.buyer,
    contractHeaders.commodity,
    contractHeaders.quantity,
    contractHeaders.deliveryPeriod,
    contractHeaders.amountLeftToDeliver,
  ],
  target: [
    contractHeaders.contractIdentifier,
    contractHeaders.buyer,
    contractHeaders.commodity,
    contractHeaders.quantity,
    contractHeaders.price,
    contractHeaders.expiryDate,
  ],
  futures: [
    contractHeaders.contractIdentifier,
    contractHeaders.commodity,
    numContractsHeader,
    positionSideHeader,
    futuresDateHeader,
    futuresPriceHeader,
  ],
  options: [
    contractHeaders.contractIdentifier,
    contractHeaders.commodity,
    numContractsHeader,
    optionStrategyHeader,
    futuresDateHeader,
    strikePriceHeader,
  ],
};

export const availableContractColumns = (typeKey) => {
  const preset = CONTRACT_TYPE_COLUMNS[typeKey] || CONTRACT_TYPE_COLUMNS.all;
  const presetValues = new Set(preset.map((column) => column.value));
  const byValue = new Map();
  [...preset, ...Object.values(contractHeaders)].forEach((header) => {
    if (!byValue.has(header.value)) {
      byValue.set(header.value, { ...header, default: presetValues.has(header.value) });
    }
  });
  return [...byValue.values()];
};

export const deliveryHeaders = {
  buyer: {
    text: 'Buyer',
    value: 'buyer',
    icon: 'mdi-truck',
    default: true,
    sortable: true,
    sortByField: 'contract_buyer',
    tableOrder: 1,
  },
  comments: {
    text: 'Comments',
    value: 'comments',
    default: true,
    sortable: true,
    sortByField: 'comments',
    tableOrder: 6,
    cellClass: 'min-w-320',
  },
  commodity: {
    text: 'Commodity',
    value: 'commodity',
    default: true,
    sortable: true,
    sortByField: 'contract_commodity',
    tableOrder: 5,
  },
  deliveryIdentifier: {
    text: 'Delivery ID',
    value: 'deliveryIdentifier',
    default: true,
    sortable: true,
    sortByField: 'delivery_identifier',
    tableOrder: 0,
  },
  deliveryDate: {
    text: 'Delivery Date',
    value: 'deliveryDate',
    default: true,
    sortable: true,
    sortByField: 'delivery_date',
    // sort: (a, b) => a.localeCompare(b), // If we need to client-side sort on mobile
    tableOrder: 4,
  },
  price: {
    text: 'Price',
    value: 'price',
    default: true,
    sortable: true,
    sortByField: 'price',
    tableOrder: 3,
    unitType: 'Price',
  },
  netQuantity: {
    text: 'Net Quantity',
    value: 'netQuantity',
    default: true,
    sortable: true,
    sortByField: 'quantity_net',
    tableOrder: 2,
    unitType: 'Production',
  },
  factors: {
    text: 'Factors',
    value: 'factors',
    sortable: true,
    sortByField: 'factors',
    tableOrder: 7,
  },
  contractIdentifier: {
    text: 'Parent Contract',
    value: 'contractIdentifier',
    sortable: true,
    sortByField: 'contract_id',
    tableOrder: 8,
  },
};

export const operationHeaders = {
  operationType: {
    text: 'Type',
    value: 'operationType',
    sortable: false,
    tableOrder: 0,
  },
  operationDate: {
    text: 'Date',
    value: 'operationDate',
    sortable: false,
    tableOrder: 1,
  },
  numberOfContracts: {
    text: '# Contracts',
    value: 'numberOfContracts',
    sortable: false,
    tableOrder: 2,
  },
  price: {
    text: 'Price',
    value: 'price',
    sortable: false,
    tableOrder: 3,
    unitType: 'Price',
  },
  outcome: {
    text: 'Outcome',
    value: 'outcome',
    sortable: false,
    tableOrder: 4,
  },
  comments: {
    text: 'Comments',
    value: 'comments',
    sortable: false,
    tableOrder: 5,
  },
};
const operationColumnsWithDefaults = () => Object.values(operationHeaders)
  .map((header) => ({ ...header, default: true }));

export const availableDeliveryColumns = () => Object.values(deliveryHeaders);
export const deliveryColumnDefaults = () => Object.values(deliveryHeaders).filter((header) => header.default);
export const availableOperationColumns = () => operationColumnsWithDefaults();
export const operationColumnDefaults = () => operationColumnsWithDefaults();

export const prependHeaders = {
  // Expand parent to see children
  expand: {
    text: '',
    value: 'data-table-expand',
    width: 56,
    sortable: false,
    align: 'center',
  },
  icon: {
    text: '',
    value: 'icon',
    width: 56,
    sortable: false,
  },
  // Used for selecting a single row item
  radioSelect: {
    text: '',
    value: 'data-table-radio-select',
    width: 56,
    sortable: false,
  },
};

export const appendHeaders = {
  // Actions that can be performed on a row item
  actions: {
    text: '',
    value: 'data-table-actions',
    width: 56,
    sortable: false,
  },
};
